import { render, staticRenderFns } from "./CustomerOrderView.vue?vue&type=template&id=655baef5"
import script from "./CustomerOrderView.vue?vue&type=script&lang=js"
export * from "./CustomerOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports